import { Controller } from '@hotwired/stimulus'
import StickySidebar from 'sticky-sidebar-v2'

export default class extends Controller {
  connect() {
    let topSpacing = 20
    topSpacing += document.querySelector('#navbar')?.clientHeight ?? 0
    topSpacing += document.querySelector('.search-bar:not(.guest-search-bar)')?.clientHeight ?? 0

    this.sidebar = new StickySidebar(this.element, {
      topSpacing,
      bottomSpacing: 20,
      containerSelector: '.sidebar-container',
      innerWrapperSelector: '.sidebar-inner'
    })
  }

  disconnect() {
    this.sidebar.destroy()
  }

  update(event) {
    this.sidebar.updateSticky(event)
  }
}
